import styled from 'styled-components'

const PricePlanActionDescriptionUi = styled.p`
  color: #64657e;
  font-size: 16px;
`

export default PricePlanActionDescriptionUi
